import DOMPurify from 'dompurify';

/**
 * Safely render HTML content with XSS sanitization.
 * Drop-in replacement for dangerouslySetInnerHTML.
 */
export function SafeHTML({ html, className = "", as: Tag = "div", ...props }) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code', 'span', 'div', 'img', 'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'class', 'style', 'width', 'height'],
    ADD_ATTR: ['target'],
  });
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: clean }} {...props} />;
}

/**
 * Sanitize HTML string and return clean HTML.
 * For cases where you need the string, not a component.
 */
export function sanitizeHTML(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code', 'span', 'div', 'img', 'hr'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'class', 'style'],
  });
}
